<div (click)="clickedInside($event)">
  <div class="input-group">
    <input
      id="search"
      type="text"
      class="form-control"
      placeholder="Search Borrower Name"
      [formControl]="searchControl"
      autocomplete="off"
      (keydown)="keydownHandler($event)"
      />
    @if (searchInProgress) {
      <span class="input-group-text">
        <i class="search-icon">
          <div class="loader search-loading-spinner"></div>
        </i>
      </span>
    } @else {
      <span class="input-group-text">
        <i class="fas fa-search search-icon"></i>
      </span>
    }
    @if (!!borrowerSearchResults?.length) {
      <ul class="dropdown">
        @for (item of borrowerSearchResults; track item; let idx = $index) {
          <li
            (click)="select(item)"
          [ngClass]="{active: idx == arrowkeyLocation}">{{item.name}}</li>
        }
      </ul>
    }
    @if (noResultsMessageIsVisible) {
      <ul class="dropdown no-results-msg">
        <li>{{noResultsMessage}}</li>
      </ul>
    }
  </div>
</div>
